import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function TriangleExclamationIcon({ color, textSize, type }) {
  return <Icon
    type={type}
    name="fa-triangle-exclamation"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

TriangleExclamationIcon.defaultProps = {
  color: colors.gray9,
  textSize: '1rem',
  type: 'fa-regular',
};

export default TriangleExclamationIcon;
